import { combineReducers } from '@reduxjs/toolkit';
import { reducer as commonReducer } from './model/common';
import { reducer as tabsReducer } from './model/tabs';
import { reducer as layoutReducer } from './model/layout';
import { reducer as vacationScheduleReducer } from './model/vacationSchedule';
import { reducer as blockedEmployeesReducer } from './model/blocked';
import { reducer as employeesReducer } from './model/employees';
import { reducer as consultationsReducer } from './model/consultations';
import { reducer as substitutionsReducer } from './model/substitutions';
import { reducer as indicatorsReducer } from './model/indicators';
import absenceReducer from './model/absence';

export * as uiModel from './model';

const uiReducer = combineReducers({
  common: commonReducer,
  tabs: tabsReducer,
  layout: layoutReducer,
  absence: absenceReducer,
  vacationSchedule: vacationScheduleReducer,
  blockedEmployees: blockedEmployeesReducer,
  employees: employeesReducer,
  consultations: consultationsReducer,
  substitutions: substitutionsReducer,
  indicators: indicatorsReducer,
});

export default uiReducer;
